<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/login-bg.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

h3{
  text-align: center;
  font-size: 25px;
}

.label{
  margin: 10px 10px 1px 10px;
}

.link{
  padding: 20px 0;
  margin: 100px 0;
  text-align: center;
  color: blue;
  text-decoration: underline;
  font-size: 16px;
}
.link:hover{
  color: black;
}

button{
  color: black;
  border: 4px black solid;
  box-shadow: 0 5px 5px gray;
  background-color: rgba(255,255,255,0.5);
}
button:hover{
  color: white;
  background-color: black;
}
button:disabled{
  color: lightgray;
  border: 4px lightgray solid;
}

.margin{
  height: 100px;
}

</style>

<Auth bind:this="{auth}"></Auth>


<Dialog show="{permaBanned}" title="Permanently Banned" buttons="{[]}" close="{false}">
  <p>We're sorry.  Your account has been permanently disabled.</p>
  <p>This is usually caused by misconduct according to our Terms and Conditions.  This can not be undone.</p>
  <p>We thank you for your business.  Goodbye.</p>
</Dialog>

<Dialog show="{accDisabled}" title="Disabled" buttons="{[]}" close="{false}">
  <p>We're sorry.  Your account has been disabled.</p>
  <p>Please try again later.</p>
</Dialog>

<Dialog show="{suspended}" title="Temporarily Suspended" buttons="{[]}" close="{false}">
  <p>We're sorry.  Your account has been temporarily suspended.</p>
  <p>Please try again in a five years.</p>
</Dialog>

  <Dialog show="{notFound}" title="Account Not Found" buttons="{[{text: 'Okay', callback: 'close', disabled: false, }]}" close="{true}" on:close="{close}">
  <p>We couldn't find that account.  Please try again.</p>
</Dialog>




<div class="bg">
  
  <h3>Log In</h3>
  
  <div class="label">Email</div>
  <div><input type="text" bind:value="{email}" on:keyup="{check}" autocapitalize="none"></div>
  
  <div class="label">Password</div>
  <div><input type="password" bind:value="{password}" on:keyup="{check}"></div>
  
  <div class="margin"></div>
  
  <button on:click="{login}" disabled="{disabled}">Log In</button>
  
  <div class="link" on:click="{ () => push('/signup/profile/type') }">Don't have an account?</div>
  
</div>


<script>

import {push, pop, replace, location} from 'svelte-spa-router';

import Auth from "../interfaces/Auth.svelte";
let auth;

import forge from "node-forge";

import Dialog from "../components/Dialog.svelte";

import Normalize from "../helpers/Normalize.js";
import Validate from "../helpers/Validate.js";
import Signin from "../helpers/Signin.js";
import StoreCrypto from "../helpers/StoreCrypto.js";

// let email = "jerkrichards@gmail.com";
// let password = "asdf123456";
let email = "";
let password = "";
let disabled = true;

let permaBanned = false;
let suspended = false;
let accDisabled = false;
let notFound = false;

import { onMount } from "svelte";
onMount(async () => {
  check();
});

function check() {
  try {
    Validate.email(email);
    Validate.password(password);
    disabled = false;
  } catch (error) {
    console.log("error:", error);
  }
}


async function login() {
  
  // console.log("email:", email);
  // console.log("password:", password);
  
  if (email != "" && password != "") {
    
    auth.message("Preparing...");
    
    email = Normalize.email(email);
    
    try {
      // await Signin.now(email, password);
      let res = await auth.post("signin", {email: email, pw: password});
      // console.log("res:", res);
      
      if (res == "+") {
        
        auth.message("Loading My Info");
        let res = await auth.post("loadMe", {fullProfile: true});
        
        // console.log("res:", res);
        
        res = JSON.parse(res);
        
        // decrypt private key
        let pkey = forge.pki.decryptRsaPrivateKey(res.pkey, password);
        pkey = forge.pki.privateKeyToPem(pkey);
        let store = StoreCrypto.decrypt(res.store, pkey, res.cert);
        
        // console.log("pkey:", pkey);
        // console.log("store:'" + store + "'");
        
        localStorage.setItem("signup", JSON.stringify({signupComplete: true}));
        localStorage.setItem("store", store);
        localStorage.setItem("pkey", pkey);
        localStorage.setItem("cert", res.cert);
        
        push("/events/popular");
      } else {
        console.log("error res:", res);
        
        if (res == "-") {
          
          // display couldn't find error
          notFound = true;
          
        } else if (res == "DISABLED") {
          // display account disabled error
          
          // delete all data from this device
          accDisabled = true;
        } else if (res == "SUSPENDED") {
          // display account suspended error
          
          // delete all data from this device
          suspended = true;
          
        } else if (res == "PERMANENTLY BANNED") {
          // display account permanently banned error
          
          // delete all data from this device
          permaBanned = true;
        }
      }
      
    } catch (error) {
      console.log("error:", error);
    }
    
  }
}


function close() {
  notFound = false;
}

</script>